import styled from 'styled-components';
import { pickThemeColor, pickThemeFontStyles } from '@/theme';

export const StyledText = styled.span`
  color: ${pickThemeColor('BLACK')};
  ${pickThemeFontStyles('16', '20', 'NORMAL')};
`;
